// Module
var code = "<massia-form form=\"true\" label=\"{{$ctrl.filter.libelle}}\"> <massia-switch model=\"$ctrl.filter.selected\"></massia-switch> </massia-form>";
// Exports
module.exports = code;